<template>
  <div class="timeline-container">
    <div class="hover-trigger">
      <div  class="hover-container drop-shadow">
        <div :style="'flex-grow: ' + flexGrowValue"></div>
        <div ref="container" @mouseleave="isSegmentClicked = false" :class="'hover-box ' + hoverExpanded">
          <div style="display: flex;">
            <h2 style="margin: 0;">{{ routeHeading }}</h2>
            <!--
            <div class="arrow-expand" @click="doExpand">
              <h2 style="margin: 0;"><span v-if="showExpanded">Show Less</span><span v-else>Show More</span></h2>
              <img :class="'arrow ' + arrowDirection">
            </div>
            -->
          </div>
          <p class="description">{{ routeParagraph }}</p>
        </div>
        <div :style="{ opacity: isSegmentClicked ? 1 : 1 }">
          <div class="triangle" :style="{ left: mousePosX + 'px' }"></div>
        </div>
      </div>
      <div class="timeline-bar drop-shadow" @mousemove="handleTimelineBarClick($event)">
        <div v-for="(segment, index) in segments" @mouseover="selectedRoute(segment.route)" :style="{ width: segment.width }"
             :key="index" :class="{ 'timeline-segment' : true, 'selected': segment.route === selectedSegment }">
        </div>
      </div>
      <div class="timeline-numbers">
        <h2 class="number">1600</h2>
        <h2 class="number">1650</h2>
        <h2 class="number">1700</h2>
        <h2 class="number">1750</h2>
        <h2 class="number">1800</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineBar",
  components: {},
  props: {},
  data() {
    return {
      screenWidth: 0,
      mousePosX: 90,
      flexGrowValue: '0.05',
      isSegmentClicked: false,
      selectedSegment: "route-1",
      showExpanded: true,
    };
  },
  computed: {
    hoverExpanded() {
      if (this.showExpanded && this.isSegmentClicked) {
        return "expanded"
      } else {
        return ""
      }
    },
    arrowDirection() {
      if (this.showExpanded) {
        return "rotate90"
      } else {
        return ""
      }
    },
    segments() {
      return [
        { width: '2.5%', route: 'route-1' },
        { width: '2.5%', route: 'route-2' },
        { width: '2.5%', route: 'route-3' },
        { width: '2.5%', route: 'route-4' },
        { width: '25%', route: 'route-5' },
        { width: '30%', route: 'route-6' },
        { width: '25%', route: 'route-7' },
        { width: '10%', route: 'route-8' }
      ];
    },
    routeHeading() {
      const selectedRoute = this.$store.getters.getSelectedRoute;
      switch (selectedRoute) {
        case 'route-1':
          return 'Setting up the company - 1602';
        case 'route-2':
          return 'Voyage of the Duyfken - 1606';
        case 'route-3':
          return 'The Trade Winds - 1611';
        case 'route-4':
          return 'Storming Indonesia - 1619';
        case 'route-5':
          return 'Growing wealthy - 1620-1670';
        case 'route-6':
          return 'Competition - 1670-1730';
        case 'route-7':
          return 'Gradual decline - 1730-1780';
        case 'route-8':
          return 'End of the line - 1780-1799';
      }
    },
    routeParagraph() {
      const selectedRoute = this.$store.getters.getSelectedRoute;
      switch (selectedRoute) {
        case 'route-1':
          return 'The Dutch began trading in Asia in the 1590s. It was so successful that some Dutch business people had an idea! They formed the Dutch East India Company (VOC) to trade in Asia. This was the first modern company ever.';
        case 'route-2':
          return 'The continent of Australia was first visited by Dutch traders when the Duyfken landed on the coast. They didn’t find anything to trade and had a battle with the Wik people who had lived there for over 50,000 years.';
        case 'route-3':
          return 'For many years, ships had sailed north from Cape Town then east to Indonesia. But explorer Hendrik Brouwer, discovered a faster route that made use of very strong winds. This reduced the time voyages took by 6 months.';
        case 'route-4':
          return 'After a long battle with the Portuguese, the VOC set up its new headquarters at a place they called Batavia in Indonesia. They destroyed many settlements and killed many people. Batavia is now called Jakarta.';
        case 'route-5':
          return 'Over the next 50 years the VOC became extremely wealthy. They traded with many Asian countries in all sorts of goods. They had over 150 merchant ships, 40 warships, 10,000 soldiers and 50,000 employees.';
        case 'route-6':
          return 'The VOC was a huge success until the 1670s. Companies from other countries started coming into Asia and the Dutch were forced to trade in less profitable things like tea, coffee and sugar. It became harder to make money.';
        case 'route-7':
          return 'Things became even more difficult as more companies moved into areas the Dutch controlled. There weren’t as many places they could trade anymore. Making matters worse, workers began stealing from the VOC.';
        case 'route-8':
          return 'War broke out between the British and Dutch. Half of all the VOC’s ships were destroyed. Then during the French Revolution, the Dutch were invaded by France and the VOC was shut down in 1799, after nearly 200 years.';
      }
    }
  },
  mounted() {
    this.updateScreenWidth();
    this.onScreenResize();
    this.selectedRoute("route-1")
  },
  methods: {
    updatePointer() {
    },
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    handleTimelineBarClick(event) {
      const targetClassList = event.target.classList;
      if (!targetClassList.contains('timeline-segment') && !targetClassList.contains('selected')) {
        return;
      }
      const containerWidth = event.currentTarget.offsetWidth;
      const clickPosition = event.clientX - event.currentTarget.getBoundingClientRect().left;
      const positionRatio = clickPosition / containerWidth;
      let clientRect = this.$refs.container.getBoundingClientRect()
      const clampedRatio = Math.max(0.05, Math.min(0.95, positionRatio));
      this.flexGrowValue = clampedRatio.toString();
      this.mousePosX = Math.max(event.clientX, clientRect.left + 20);
      this.mousePosX = Math.min(this.mousePosX, clientRect.right - 20);
    },
    selectedRoute(route) {
      this.$store.commit("setSelectedRoute", route);
      this.isSegmentClicked = true;
      this.selectedSegment = route;
    }
  }
};
</script>

<style scoped>
.timeline-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column-reverse;
}
.timeline-bar {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 4.5em;
  height: 1.5em;
  background-color: var(--blue);
  outline: 2px solid var(--indigo);
}
.timeline-segment {
  width: 2.5%;
  height: 100%;
  background-color: var(--light-blue);
  border: 2px solid var(--indigo);
  border-radius: 0.25em;
  margin: 0 -1px;
  position: relative;
  transition: 0.5s;
}
.timeline-segment.selected {
  background-color: var(--orange);
  animation: pulse alternate 2s ease-in-out infinite;
}
@keyframes pulse {
  0% { filter: brightness(100%); }
  100% { filter: brightness(115%); }
}
.timeline-numbers {
  display: flex;
  justify-content: space-between;
  margin: 0 3em 0;
  filter: drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo));
}
.number {
  line-height: 0.25em;
  padding-bottom: 0.5em;
}
.hover-container {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  padding: 0 1.5em;
  position: relative;
}
.hover-box {
  width: 27em;
  height: 1.5em;
  color: var(--indigo);
  background-color: var(--light-blue);
  border: 0.75em solid var(--light-blue);
  border-radius: 0.25em;
  text-align: left;
  transition: 0.25s;
  overflow-y: hidden;
}
.description {
  margin-top: 0.5em;
  margin-bottom: 0;
}
.triangle {
  position: absolute;
  bottom: -0.75em;
  left: 50%;
  transform: translateX(-50%);
  border-left: 0.5em solid transparent;
  border-right: 0.5em solid transparent;
  border-top: 0.75em solid var(--light-blue);
}
.expanded {
  height: 6.6em;
}
</style>